export const AUTH_LOGOUT_EVENT = "auth:logout";
export const AUTH_LOGOUT_SYNC_KEY = "auth:logout-at";

export function getAccessToken() {
  const primary = String(localStorage.getItem("token") || "").trim();
  if (primary) return primary;
  return String(localStorage.getItem("accessToken") || "").trim();
}

export function setAccessToken(token) {
  const value = String(token || "").trim();
  if (!value) return;
  // Keep both keys during migration to avoid breaking older code paths.
  localStorage.setItem("token", value);
  localStorage.setItem("accessToken", value);
}

export function getRefreshToken() {
  return String(localStorage.getItem("refreshToken") || "").trim();
}

export function setRefreshToken(token) {
  const value = String(token || "").trim();
  if (!value) return;
  localStorage.setItem("refreshToken", value);
}

export function clearAuthStorage() {
  try {
    localStorage.setItem(AUTH_LOGOUT_SYNC_KEY, String(Date.now()));
  } catch (_err) {
    // Ignore storage failures and still clear known auth keys.
  }
  localStorage.removeItem("token");
  localStorage.removeItem("accessToken");
  localStorage.removeItem("refreshToken");
  localStorage.removeItem("user");
  localStorage.removeItem("userPayload");
}

export function notifyForcedLogout() {
  try {
    window.dispatchEvent(new CustomEvent(AUTH_LOGOUT_EVENT));
  } catch (_err) {
    // Ignore environments where window/CustomEvent is unavailable.
  }
}
